import { Glyphicon } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import Button from 'components/button/Button';
import GenericFormField from 'components/forms/genericFormField/GenericFormField';
import TextField from 'components/forms/textField/TextField';

interface PropertyVrboSettingsPolicyPeriodFieldProps {
  index: number;
  onDelete: () => void;
}

const PropertyVrboSettingsPolicyPeriodField = ({
  index,
  onDelete,
}: PropertyVrboSettingsPolicyPeriodFieldProps) => {
  const { t } = useTranslation();

  const fieldRenderer = () => {
    return (
      <div className="policy-period">
        <TextField
          label=""
          name={`vrboSettings.customCancellationPolicies.${index}.refundPercentage`}
          rightAddons={['%']}
          colSmInput={12}
          type="number"
        />
        <span>
          {t('pageProperty.mainSettings.vrboSettings.policyPeriods.refundUpTo')}
        </span>
        <TextField
          label=""
          name={`vrboSettings.customCancellationPolicies.${index}.refundThreshold`}
          rightAddons={[t('common.days')]}
          colSmInput={12}
          type="number"
        />
        <span>
          {t(
            'pageProperty.mainSettings.vrboSettings.policyPeriods.beforeCheckIn',
          )}
        </span>
        {index !== 0 && (
          <Button
            bsStyle="link"
            data-testid="delete-custom-policy-button"
            onClick={onDelete}
          >
            <Glyphicon glyph="remove-sign" />
          </Button>
        )}
      </div>
    );
  };

  return (
    <GenericFormField
      containerClassName="policy-period-field"
      fieldRenderer={fieldRenderer}
      label={t('pageProperty.mainSettings.vrboSettings.policyPeriods.label', {
        value: index + 1,
      })}
      name={`vrboSettings.customCancellationPolicies.${index}`}
      colSmInput={7}
      colSmLabel={5}
    />
  );
};

export default PropertyVrboSettingsPolicyPeriodField;
